import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';
import Spinner from '~/icons/spinner.svg';

const ROTATING_ANIMATION = keyframes({
    to: { transform: 'rotate(360deg);' },
});

export const LoaderSpinner = styled(Spinner)(({ theme }) => ({
    width: '40px',
    height: '40px',
    marginRight: 'calc(' + theme.space[3] + ' - ' + theme.space[1] + ')',
    marginTop: '2px',
    animationName: ROTATING_ANIMATION,
    animationDuration: '1.5s',
    animationIterationCount: 'infinite',
}));

export const StyledLoaderContainer = styled.div({
    border: '1px solid red',
    display: 'flex',
});
